import React, { useState } from "react";
import { Card, Container, Row, Col, Form, Button, Image } from "react-bootstrap";
import { motion } from "framer-motion";
import AboutUsImage from "../Assets/AboutUs.webp";

const AdminAboutUs = () => {
    const [aboutUs, setAboutUs] = useState({
        title: "Madhu Sewing Machine Sales & Services",
        description: "Your one-stop destination for high-quality sewing machines, expert repairs, and premium spare parts.",
        services: ["Sewing Machines", "Machine Repairs", "Customization", "Spare Parts"],
        whyChooseUs: [
            "10+ Years of Experience",
            "High-Quality Products & Services",
            "Expert Technicians",
            "Affordable Pricing",
            "Customer Satisfaction Guaranteed",
            "Quick Service Turnaround"
        ],
        commitment: [
            { title: "Innovative Solutions", description: "We continuously improve our products and services to meet customer needs." },
            { title: "Customer First", description: "We prioritize customer satisfaction and strive for excellence in service." },
            { title: "Sustainability", description: "We use eco-friendly practices and promote sustainability in our operations." }
        ],
        contact: {
            address: "123 Sewing Lane, Textile City",
            phone: "+91 9876543210",
            email: "support@madhu-sewing.com",
            hours: "Monday - Friday: 9:00 AM - 6:00 PM",
            mapLink: "https://www.google.com/maps/embed?pb=..." // Replace with actual Google Maps link
        }
    });

    const handleChange = (section, value, index = null, field = null) => {
        if (index !== null) {
            const updatedArray = [...aboutUs[section]];
            if (field) updatedArray[index][field] = value;
            else updatedArray[index] = value;
            setAboutUs({ ...aboutUs, [section]: updatedArray });
        } else {
            setAboutUs({ ...aboutUs, [section]: value });
        }
    };

    return (
        <Container className="py-5 mt-5">
            {/* About Us Section */}
            <Row className="mb-5 align-items-center">
                <Col md={6}>
                    <Image src={AboutUsImage} fluid rounded className="shadow-lg" alt="Company" />
                    <Form.Control type="text" className="mt-2" placeholder="Update Image URL" />
                </Col>
                <Col md={6}>
                    <Form.Control
                        type="text"
                        className="mb-3"
                        value={aboutUs.title}
                        onChange={(e) => handleChange("title", e.target.value)}
                    />
                    <Form.Control
                        as="textarea"
                        rows={3}
                        value={aboutUs.description}
                        onChange={(e) => handleChange("description", e.target.value)}
                    />
                </Col>
            </Row>

            {/* Services Section */}
            <Row className="text-center">
                {aboutUs.services.map((service, index) => (
                    <Col md={3} key={index} className="mb-4">
                        <Form.Control
                            type="text"
                            value={service}
                            onChange={(e) => handleChange("services", e.target.value, index)}
                        />
                    </Col>
                ))}
            </Row>

            {/* Why Choose Us Section */}
            <Card className="p-4 shadow-lg text-center mb-5">
                <h2 className="fw-bold">Why Choose Us?</h2>
                <Row>
                    {aboutUs.whyChooseUs.map((reason, index) => (
                        <Col md={6} key={index}>
                            <Form.Control
                                type="text"
                                value={reason}
                                onChange={(e) => handleChange("whyChooseUs", e.target.value, index)}
                            />
                        </Col>
                    ))}
                </Row>
            </Card>

            {/* Commitment Section */}
            <Row>
                {aboutUs.commitment.map((item, index) => (
                    <Col md={4} key={index}>
                        <Card className="p-4 shadow-lg">
                            <Form.Control
                                type="text"
                                value={item.title}
                                onChange={(e) => handleChange("commitment", e.target.value, index, "title")}
                                className="mb-2"
                            />
                            <Form.Control
                                as="textarea"
                                value={item.description}
                                onChange={(e) => handleChange("commitment", e.target.value, index, "description")}
                            />
                        </Card>
                    </Col>
                ))}
            </Row>

            {/* Contact Section */}
            <Row className="mt-5">
                <Col md={6}>
                    <Card className="p-4 shadow-lg">
                        <h2 className="fw-bold">Contact Us</h2>
                        <Form.Control type="text" className="mb-2" value={aboutUs.contact.address} onChange={(e) => handleChange("contact", { ...aboutUs.contact, address: e.target.value })} />
                        <Form.Control type="text" className="mb-2" value={aboutUs.contact.phone} onChange={(e) => handleChange("contact", { ...aboutUs.contact, phone: e.target.value })} />
                        <Form.Control type="text" className="mb-2" value={aboutUs.contact.email} onChange={(e) => handleChange("contact", { ...aboutUs.contact, email: e.target.value })} />
                        <Form.Control type="text" className="mb-2" value={aboutUs.contact.hours} onChange={(e) => handleChange("contact", { ...aboutUs.contact, hours: e.target.value })} />
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="p-4 shadow-lg">
                        <h2 className="fw-bold">Google Maps Link</h2>
                        <Form.Control type="text" value={aboutUs.contact.mapLink} onChange={(e) => handleChange("contact", { ...aboutUs.contact, mapLink: e.target.value })} />
                        <iframe src={aboutUs.contact.mapLink} width="100%" height="300" style={{ border: 0 }} allowFullScreen="" loading="lazy"></iframe>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default AdminAboutUs;
